import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { loadConsentDetails } from "../../../../Redux/actions/consentAction";
import CBPreviewConsent from "./CBPreviewConsent";
import ConsentPropertiesModalWrapper from "../ConsentProperties/ConsentPropertiesModalWrapper";
import { Backdrop, Typography } from "@mui/material";
import { resetConsentState } from "../../../../Redux/reducers/consentSlice";
import { CBArea, CBMessageWrapper } from "../block.style";
import CBEmptyPreview from "./CBEmptyPreview";
import CBPreviewHeader from "./CBPreviewHeader";
import Loader from "../../../Common/assets/Loader";

type Props = {
  studyId: string;
  formId: string;
  versionId: string;
  type: "platform" | "study";
  editable: boolean;
  formType?: "consent" | "sunshine";
};
const ConsentPreview: React.FC<Props> = ({
  studyId,
  versionId,
  formId,
  type,
  editable,
  formType,
}) => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.consent.loading);
  const error = useAppSelector((state) => state.consent.error);
  const blocks = useAppSelector((state) => state.consent.blocks);

  useEffect(() => {
    if (studyId && formId && versionId && type === "study")
      dispatch(
        loadConsentDetails(
          studyId,
          formId,
          versionId,
          type,
          editable,
          true,
          formType
        )
      );
    else if (formId && versionId && type === "platform")
      dispatch(
        loadConsentDetails(
          "",
          formId,
          versionId,
          type,
          editable,
          true,
          formType
        )
      );
    return () => {
      dispatch(resetConsentState());
    };
  }, [dispatch, studyId, formId, versionId, editable, type, formType]);

  return (
    <div className="preview-wrapper">
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}
      <CBPreviewHeader consentEditable={editable} />
      {error ? (
        <CBMessageWrapper>
          <Typography variant="h3" color="grey">
            {error}
          </Typography>
        </CBMessageWrapper>
      ) : (
        <CBArea style={{ padding: "0px" }}>
          {loading ? null : blocks.length === 0 ? (
            <CBEmptyPreview />
          ) : (
            <CBPreviewConsent />
          )}
          <ConsentPropertiesModalWrapper />
        </CBArea>
      )}
    </div>
  );
};

export default ConsentPreview;
